import { h } from 'preact';
import { useState, useLayoutEffect, useRef } from 'preact/hooks';

// A link that shows a photo in an overlay inside the app. A plain target="_blank" link
// opens the bare image in the installed app's own window on iOS, with no way back.
// Modified clicks (new tab, ctrl/cmd) still follow the href.
export default function PhotoLink({ src, alt = 'Foto', children }) {
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const link = useRef(null);
  const close = useRef(null);

  useLayoutEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    const onKey = e => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    close.current?.focus();
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      link.current?.focus();
    };
  }, [open]);

  function onClick(e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    setFailed(false);
    setLoaded(false);
    setOpen(true);
  }

  return (
    <>
      <a ref={link} href={src} target="_blank" rel="noopener" onClick={onClick}>{children}</a>
      {open && (
        <div class="photo-overlay" role="dialog" aria-modal="true" aria-label={alt}
          onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}>
          <button ref={close} type="button" class="photo-overlay-close" onClick={() => setOpen(false)} aria-label="Sluiten">&times;</button>
          {failed
            ? <p class="photo-overlay-error">De foto kon niet worden geladen.</p>
            : <>
                {!loaded && <p class="photo-overlay-loading" role="status"><span class="btn-spinner" aria-hidden="true" /> Foto laden…</p>}
                <img src={src} alt={alt} style={loaded ? undefined : 'display:none'} onLoad={() => setLoaded(true)} onError={() => setFailed(true)} />
              </>}
        </div>
      )}
    </>
  );
}
